export function getToCompanyContactName(toNames: string[]): string {
  // If the only user is 'RQ Admin', display 'Adviser' instead
  if (toNames.length === 1 && toNames[0] === 'RQ') {
    return 'Adviser'
  }

  // If there are multiple users, always prefer names of other users over
  // the 'RQ Admin' user
  const toNamesSorted = toNames.slice().sort((nameA, nameB) => {
    if (nameA === 'RQ' || nameB === 'RQ') {
      return -1
    }

    return 0
  })

  return toNamesSorted.length > 1
    ? `${toNamesSorted[0]} and team`
    : `${toNamesSorted[0]}`
}
